import {Component} from '@angular/core';
import {InfoModalComponent} from "app/views/modal/info_modal.component";

@Component({
	templateUrl: './logs.component.html'
})
export class LogsModalComponent extends InfoModalComponent {
	stats: any[];
	type: string;


	paymentTypeMap = {
		99: 'Оплачено безналом',
		999: 'Даётся бесплатно',
		9999: 'Номер заказа Divly',
	};
	
	
	periodTypeMap = {
		1: 'Предустановленные',
		2: 'Произвольная дата окончани',
		3: 'Произвольное количество дней',
	};
	
	ok() {
		this.close();
	}
}
